<template>
  <StoryCommentThread
    v-if="!showsSampleComments && storyEntityId > 0 && !commentsFolded"
    :story-id="storyEntityId"
    :width="myWidth"
    :font-color="myFontColor"
    :active-icon-color="myActiveIconColor"
  />
  <iStyledCard
    v-else-if="showsSampleComments"
    title="Comments"
    width="fill"
    :style-overrides="{
      cardTitleFontColor: myFontColor,
      cardSubtitleFontColor: myFontColor,
      cardAuthorNameFontColor: myFontColor,
      cardAuthorDescriptionFontColor: myFontColor,
      cardAuthorAuthorTagFontColor: myFontColor,
      cardDescriptionFontColor: myFontColor,
      cardTagFontColor: myFontColor,
      cardMetricValueFontColor: myFontColor,
      cardMetricNameFontColor: myFontColor,
      cardPaddingLeft: 'none',
      cardPaddingRight: 'none',
      cardPaddingTop: 'none',
      cardPaddingBottom: 'none',
    }"
    @click.prevent=""
  >
    <template #description>
      <iColumn gap="small">
        <iRow
          v-for="(comment, idx) in placeholderComments"
          :key="idx"
          gap="small"
          width="fill"
          :style-overrides="{
            paddingTop: 'small',
            paddingBottom: 'small',
            borderRadius: 'standard',
          }"
        >
          <iColumn gap="extraSmall" width="fill">
            <iText
              font-weight="strong"
              :style-overrides="{standardFontColor: myFontColor}"
            >
              {{ comment.author }}
            </iText>
            <iText :style-overrides="{standardFontColor: myFontColor}">
              {{ comment.body }}
            </iText>
          </iColumn>
        </iRow>
      </iColumn>
    </template>
  </iStyledCard>
</template>

<script>
// `%/apps/conversations/components/comments/CommentThread.vue` lives
// outside the editor directory tree. Canvas preview renders an
// inline comments mockup.
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import FontColor from "%/dynamic-component-editor/options/font-color";
import ActiveIconColor from "%/dynamic-component-editor/options/active-icon-color";
import {
  CommentsWidgetElementMixin,
} from "%/dynamic-component-editor/standard-elements/comments-widget/comments-widget-element-mixin";
import StoryCommentThread from "%/dynamic-component-editor/components/story-comments/StoryCommentThread.vue";

export default {
  name: "Comments",
  components: { StoryCommentThread },
  mixins: [CommentsWidgetElementMixin],
  elementPanelSettings: {
    displayName: "Comments",
    displayIcon: "list",
    elementGroup: "commentWidgetElements",
    elementType: "element",
  },
  computed: {
    placeholderComments() {
      return [
        { author: "Alex", body: "This is great, thanks for sharing!" },
        { author: "Sam", body: "I'd love to see a follow-up on this topic." },
      ];
    },
    myFontColor() {
      return this.getOptionValue(FontColor);
    },
    myActiveIconColor() {
      return this.getOptionValue(ActiveIconColor);
    },
    myWidth() {
      return this.getOptionValue(LayoutWidth);
    },
  },
  options: [
    new LayoutWidth({
      "default": "fill",
      "hover": "fill",
    }, true),
    new FontColor({
      "default": {
        "value": "standard",
        "source": "theme.font",
      },
    }),
    new ActiveIconColor({ "default": "" }),
  ],
};
</script>
